import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import IconTooltipButton from "../../../../../../button/IconTooltipButton";
import { Chip } from "@mui/material";

const ListApiKeys = ({ list = [], isLoading, permissions, onModal }) => {
  if (isLoading) {
    return (
      <List>
        {Array(4)
          .fill()
          .map((_, i) => (
            <ListItem key={i}>
              <ListItemIcon>
                <Skeleton variant="circular" width="2rem" height="2rem" />
              </ListItemIcon>
              <Skeleton variant="text" width={300} />
            </ListItem>
          ))}
      </List>
    );
  }
  if (list.length === 0)
    return (
      <Typography
        variant="inherit"
        component={"p"}
        className="text-muted-foreground opacity-50 py-2 px-2"
      >
        You don't have any keys apps yet
      </Typography>
    );

  return (
    <List>
      {list.map((item) => (
        <ListItem button key={item._id}>
          <ListItemText
            primary={item?.name}
            secondary={
              <div className="flex flex-col gap-1">
                <Typography
                  variant="inherit"
                  component={"span"}
                  className="text-muted-foreground opacity-50 text-sm"
                >
                  {item?.description}
                </Typography>
                <div className="flex gap-2">
                  {item.permissions.length > 0 &&
                    item.permissions.map((permission, index) => (
                      <Chip
                        key={index}
                        className="capitalize"
                        component={"span"}
                        size="small"
                        label={permission}
                        color="primary"
                        variant="outlined"
                      />
                    ))}
                </div>
              </div>
            }
          />

          <ListItemSecondaryAction>
            {permissions["preview"] && (
              <IconTooltipButton
                title="Preview"
                icon="expand-alt"
                onClick={() => onModal("preview", item)}
              />
            )}
            {permissions["deleted"] && (
              <IconTooltipButton
                title="Delete"
                icon={["fas", "trash-alt"]}
                onClick={() => onModal("delete", item)}
              />
            )}
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default ListApiKeys;
